export default __webpack_public_path__ + "static/media/dbms.50ca9273.png";